// extracted by mini-css-extract-plugin
export default {"link":"_1-obNoLjTdBU5y_LqHOXk9"};